import { render, staticRenderFns } from "./ButtonActions.vue?vue&type=template&id=40a4c769&scoped=true&"
import script from "./ButtonActions.vue?vue&type=script&lang=js&"
export * from "./ButtonActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4c769",
  null
  
)

export default component.exports